import onDocumentHiddenOnce from './on-document-hidden-once';

/**
 * Creates a new instance of a PerformanceObserver that observes entries
 * until the first time that the browser tab loses focus.
 */
const registerPerformanceObserver = (
  type: string,
  onObservation: (list: PerformanceObserverEntryList) => void,
  onDisconnect?: () => void
) => {
  if (document.hidden) {
    return;
  }

  try {
    const observer = new PerformanceObserver(onObservation);
    observer.observe({ type, buffered: true });
    onDocumentHiddenOnce(() => {
      observer.takeRecords();
      observer.disconnect();
      if (onDisconnect) onDisconnect();
    });
  } catch (e) {
    // Do nothing if browser doesn't support PerformanceObserver.
  }
};

export default registerPerformanceObserver;
